import { postRequest, patchRequest, deleteRequest } from "@react/helpers/fetch"

export const createAvenant = (projectId, body) =>
  postRequest({ url: `/projects/${projectId}/avenants.json`, body: { avenant: body } })

export const updateAvenant = (projectId, id, body) =>
  patchRequest({ url: `/projects/${projectId}/avenants/${id}.json`, body: { avenant: body } })

export const signAvenant = (projectId, id, signedDate) =>
  patchRequest({ url: `/projects/${projectId}/avenants/${id}/sign.json`, body: { signed_date: signedDate } })

export const cancelAvenant = (projectId, id) =>
  patchRequest({ url: `/projects/${projectId}/avenants/${id}/cancel.json`, body: {} })

export const destroyAvenant = (projectId, id) =>
  deleteRequest(`/projects/${projectId}/avenants/${id}.json`)

export const submitAvenant = (projectId, id) =>
  patchRequest({ url: `/projects/${projectId}/avenants/${id}/submit.json`, body: {} })

export const refuseAvenant = (projectId, id) =>
  patchRequest({ url: `/projects/${projectId}/avenants/${id}/refuse.json`, body: {} })

export const createPricedAvenant = (projectId, body) =>
  postRequest({ url: `/projects/${projectId}/avenants/quote.json`, body: { avenant: body } })
